import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import * as XLSX from 'xlsx';

function formatDateToBrazilian(dateStr) {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}

export async function generatePdf(records, dynamicDates) {
  let title_pdf = 'IAF - Incentivo de Atividade Física'
  let titlePdfSave = title_pdf.replace(/\s/g, '_')
  let description_pdf = 'Práticas corporais e atividades físicas realizadas na UBS nos últimos 4 meses'
  
  let headers_pdf = ['CNES', 'Unidade de Saúde']
  if (dynamicDates && dynamicDates.length) {
    dynamicDates.forEach(date => headers_pdf.push(date))
  }
  
  let data_pdf = records.map(record => {
    let row = [record.cnes, record.unidade_saude]
    dynamicDates.forEach((_, i) => row.push(record[`mes${i + 1}`]))
    return row
  })
  
  let doc = new jsPDF(utils.methods.encryptionPdf())

  try {
    const base64data = await utils.methods.fileToBase64(store.state.infoMunicipio.brasao)

    // Cabeçalho da página principal
    let verticalPosition = utils.methods.headerPdf(doc, base64data, title_pdf, description_pdf) + 6
    const hoje = new Date()
    const dataAtual = `${String(hoje.getDate()).padStart(2, '0')}/${String(hoje.getMonth() + 1).padStart(2, '0')}/${hoje.getFullYear()}`

    doc.setFontSize(12)
    doc.text(`Data: ${dataAtual}`, 15, verticalPosition)
    verticalPosition += 8
    doc.text("Atividades coletivas por Unidade Básica de Saúde", 15, verticalPosition)

    verticalPosition += 2
    doc.autoTable({
      head: [headers_pdf],
      body: data_pdf,
      startY: verticalPosition,
      headStyles: { fillColor: '#ccc', fontSize: 6, textColor: '#000', halign: 'center' },
      bodyStyles: { halign: 'center', fontSize: 6 },
      theme: 'striped'
    })

    // rodapé tabela principal
    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

    // Criação de cada página adicional (detalhes)
    for (const record of records) {
      doc.addPage()

      let verticalPosition = utils.methods.headerPdf(doc, base64data, title_pdf, description_pdf) + 6
      
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition)
      verticalPosition += 6
      doc.text(`CNES: ${record.cnes}`, 15, verticalPosition)
      verticalPosition += 6
      doc.text(`UBS: ${record.unidade_saude}`, 15, verticalPosition)
      verticalPosition += 12
      doc.text("Atividades coletivas realizadas na UBS", 15, verticalPosition)

      verticalPosition += 4

      const detailsHeaders = ['Data', 'Profissional', 'CBO', 'Participantes']
      const detailsData = (record.details || []).map(detail => [
        formatDateToBrazilian(detail.data),
        detail.no_profissional,
        detail.no_cbo,
        detail.nu_participantes
      ])

      doc.autoTable({
        head: [detailsHeaders],
        body: detailsData,
        startY: verticalPosition,
        headStyles: { fillColor: '#ccc', fontSize: 6, textColor: '#000', halign: 'center' },
        bodyStyles: { fontSize: 6, halign: 'center' },
        theme: 'striped'
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
    }

    doc.save(`${titlePdfSave}.pdf`)

    vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', { position: 'topRight' })
  } catch (error) {
    console.error(error)
    vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' })
  }
}


export async function exportTeamPdf(team) {
  const title_pdf = 'IAF - Incentivo de Atividade Física';
  const titlePdfSave = title_pdf.replace(/\s/g, '_');
  const description_pdf = 'Práticas corporais e atividades físicas realizadas na UBS nos últimos 4 meses';

  const detailsHeaders = ['Data', 'Profissional', 'CBO', 'Participantes'];
  const detailsData = (team.details || []).map(detail => [
    formatDateToBrazilian(detail.data),
    detail.no_profissional,
    detail.no_cbo,
    detail.nu_participantes
  ]);

  const doc = new jsPDF(utils.methods.encryptionPdf());

  try {
    const base64data = await utils.methods.fileToBase64(store.state.infoMunicipio.brasao);
    let verticalPosition = utils.methods.headerPdf(doc, base64data, title_pdf, description_pdf) + 6;

    const hoje = new Date();
    const dataAtual = `${String(hoje.getDate()).padStart(2, '0')}/${String(hoje.getMonth() + 1).padStart(2, '0')}/${hoje.getFullYear()}`;

    doc.setFontSize(12);
    doc.text(`Data: ${dataAtual}`, 15, verticalPosition);
    verticalPosition += 6;

    doc.text(`CNES: ${team.cnes}`, 15, verticalPosition);
    verticalPosition += 6;
    
    doc.text(`UBS: ${team.unidade_saude}`, 15, verticalPosition);
    verticalPosition += 12;

    doc.text("Atividades coletivas realizadas na UBS", 15, verticalPosition);
    verticalPosition += 4;

    doc.autoTable({
      head: [detailsHeaders],
      body: detailsData,
      startY: verticalPosition,
      headStyles: { fillColor: '#ccc', fontSize: 6, textColor: '#000', halign: 'center' },
      bodyStyles: { fontSize: 6, halign: 'center' },
      theme: 'striped'
    });

    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY);
    doc.save(`${titlePdfSave}_${team.cnes}.pdf`);

    vue.$toast.success('PDF da equipe gerado com sucesso!', 'Sucesso:', { position: 'topRight' });
  } catch (error) {
    console.error(error);
    vue.$toast.error('Erro ao gerar PDF da equipe', 'Erro:', { position: 'topRight' });
  }
}

export function exportarXlsCustomizado(dados, nomeArquivo, cidade, titulo, descricao_secretaria, descricao, dataAtual, subtitulo) {
  const wb = XLSX.utils.book_new();

  const ws = XLSX.utils.aoa_to_sheet([]);

  const subtituloLinhas = subtitulo.split('\n');

  // Header personalizado na parte superior
  const headerRows = [
    [cidade],
    [descricao_secretaria],
    [titulo],    
    [descricao],
    [`Data: ${dataAtual}`],
    ...subtituloLinhas.map(linha => [linha]),
    [], // Linha vazia para espaçamento
  ];

  // Adiciona o header personalizado (começando em A1)
  XLSX.utils.sheet_add_aoa(ws, headerRows, { origin: 'A1' });

  // Calcula a posição inicial dos dados (linha após o cabeçalho personalizado)
  const dataStartRow = headerRows.length + 1; // começa após as linhas do header personalizado

  // ordem das colunas
  const columnOrder = [
    'CNES',
    'Unidade de Saúde',
    'MES',
    'Data',
    'Profissional',
    'CBO',
    'Participantes',
  ];

  // Adiciona os dados principais (tabela), garantindo a ordem correta das colunas
  XLSX.utils.sheet_add_json(ws, dados, { origin: `A${dataStartRow}`, header: columnOrder });

  // Adiciona a planilha ao workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Dados');

  // Faz download diretamente
  XLSX.writeFile(wb, `${nomeArquivo}.xlsx`);
}
